import { getBaseBreadcrumb } from 'site-modules/shared/components/breadcrumbs/helper';
import { BASE_BREADCRUMBS } from 'site-modules/shared/constants/editorial/editorial';

export const ABOUT_BREADCRUMB = getBaseBreadcrumb('About', '/about/');

export const COPYRIGHT_TRADEMARK_PATHNAME = '/copyright-trademark-notices/';

export const COPYRIGHT_TRADEMARK_BREADCRUMBS = [
  ...BASE_BREADCRUMBS.HOME,
  getBaseBreadcrumb('Copyright Notice & Trademark Notice', COPYRIGHT_TRADEMARK_PATHNAME),
];

export const COPYRIGHT_TRADEMARK_CONTENT_PATH = '/about/copyright-trademark-notices';
